import React, { useRef, useEffect } from 'react';
import AdvancedEditor from './index';
import {
  useAdvancedEditorStore,
  usePrintsOrderStore,
  usePrintsConfigStore,
} from '../../stores';
import { selectSizesWithPhotos } from '../../stores/selectors';
import { useAvailableSizesForSelectedDeliveryAndFinish } from '../../hooks/use-available-sizes-for-selected-delivery-and-finish';

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const AdvancedEditorWrapper = () => {
  const advancedEditorRef = useRef(null); // ref to call editor directly
  const isOpen = useAdvancedEditorStore((state) => state.isOpen);
  const prevIsOpen = usePrevious(isOpen);
  const clientUuid = useAdvancedEditorStore((state) => state.clientUuid);
  const isLastPhoto = useAdvancedEditorStore((state) => state.isLastPhoto);
  const availableSizes = useAvailableSizesForSelectedDeliveryAndFinish();

  // Handle incoming state changes triggered by event handler
  // Fetch photo and size data to pass to advanced editor
  useEffect(() => {
    if (prevIsOpen && !isOpen && advancedEditorRef.current) {
      advancedEditorRef.current.component.close();
    } else if (!prevIsOpen && isOpen && advancedEditorRef.current) {
      const photos = usePrintsOrderStore.getState().photos;
      const allSizes = usePrintsConfigStore.getState().allSizes;
      const sizesWithPhotos = selectSizesWithPhotos(allSizes, photos);

      const relevantPhoto = photos.find((p) => p.client_uuid === clientUuid);

      if (relevantPhoto && relevantPhoto.quantity) {
        const targetSize = sizesWithPhotos.find(
          (size) => size.key === relevantPhoto.sizeKey,
        );
        if (targetSize) {
          advancedEditorRef.current.component.setData({
            photo: { ...relevantPhoto, isLastPhoto },
            sizeArea: targetSize.area,
            availableSizes,
            sizes: sizesWithPhotos,
          });
        }
      }
    }
  }, [isOpen, prevIsOpen, clientUuid, isLastPhoto, availableSizes]);

  return (
    <AdvancedEditor
      ref={advancedEditorRef}
      onQuantityChanged={() => {
        // Stub function to avoid warning from the AdvancedEditor component - this is not used
      }}
    />
  );
};

export default AdvancedEditorWrapper;
